module.exports = __webpack_public_path__ + "media/images/arrow-next-e835f1e126ee6612333b2ae3765bd5a5.svg";